import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { dashboardByIdDataSelector } from "../dashboardByIdDataSelector";
import { CategoryDetails } from "@/services/cloudchipr.api";

export const dashboardDimensionsCategoryIdsByDashboardIdSelector =
  createDraftSafeSelector(
    [dashboardByIdDataSelector],
    (data): CategoryDetails => {
      return data?.category_details ?? null;
    },
  );
